import { render, staticRenderFns } from "./NotificationContainer.vue?vue&type=template&id=45ddd585&"
import script from "./NotificationContainer.vue?vue&type=script&lang=ts&"
export * from "./NotificationContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45ddd585')) {
      api.createRecord('45ddd585', component.options)
    } else {
      api.reload('45ddd585', component.options)
    }
    module.hot.accept("./NotificationContainer.vue?vue&type=template&id=45ddd585&", function () {
      api.rerender('45ddd585', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/notification/NotificationContainer.vue"
export default component.exports